import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { SwitchDialogWindows, Header3Text, SpruceHelpInlineLink } from '../../../components';
import { EditSingleFieldModal } from './EditSingleFieldModal';
import { eEditSingleFieldInputType } from './eEditSingleFieldInputType';

export interface IEditSingleFieldFormProps<T> {
  actions: {
    onClose: () => void;
    doSubmit: (x: T) => Promise<{ message: string }>;
  };
  displayLabel: string;
  value: T;
  validationSchema: any;
  inputType: eEditSingleFieldInputType;
}

export const EditSingleFieldForm = <T extends any>(props: IEditSingleFieldFormProps<T>) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    validationSchema,
    value,
    displayLabel,
    inputType,
    actions: { doSubmit, onClose },
  } = props;

  const successTitle = `${displayLabel} has been updated!`;
  const successMessage = 'Documents were regenerated and fees were recalculated.';

  const errorTitle = (
    <Header3Text>
      {displayLabel} cannot be updated. Please <SpruceHelpInlineLink /> to submit a request for help.
    </Header3Text>
  );

  return (
    <Formik
      validationSchema={yup.object({ value: validationSchema })}
      initialValues={{ value }}
      onSubmit={async ({ value }) => {
        try {
          await doSubmit(value);
        } catch (error: any) {
          setErrorMessage(error.message);
        }
        setIsCompleted(true);
      }}
    >
      {({ isSubmitting, isValid }) => (
        <Form>
          <SwitchDialogWindows
            isLoading={isSubmitting}
            loadingTitle={`Working...`}
            isCompleted={isCompleted}
            isError={!!errorMessage}
            successTitle={successTitle}
            successMessage={successMessage}
            errorTitle={errorTitle}
            errorMessage={errorMessage}
            onCloseClick={onClose}
          >
            <EditSingleFieldModal
              disableSubmitButton={isSubmitting || !isValid}
              onClose={onClose}
              displayLabel={displayLabel}
              inputType={inputType}
            />
          </SwitchDialogWindows>
        </Form>
      )}
    </Formik>
  );
};
